module.exports = __webpack_public_path__ + "static/media/view-icon.4bc561e4.svg";